(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-question").forEach((item) => {
    item.addEventListener("click", function () {
      this.classList.toggle("active");
      const answer = this.nextElementSibling;

      if (answer.classList.contains("open")) {
        answer.classList.remove("open");
      } else {
        document.querySelectorAll(".faq-answer").forEach(a => a.classList.remove("open"));
        document.querySelectorAll(".faq-question").forEach(q => q.classList.remove("active"));
        answer.classList.add("open");
        this.classList.add("active");
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
